import { useEffect, useState } from "react";
import { subscribeMeshStatus, getMeshStatus } from "@/lib/lanMesh";

/**
 * useMeshStatus() — reactive snapshot of the LAN mesh.
 *
 * Returns:
 *   { status: "lan" | "cloud" | "offline" | "idle", peerCount, peers, self }
 *
 *   • "lan"     → at least one peer connected via WebRTC data channel
 *   • "cloud"   → signalling socket up but no peers (cloud fallback only)
 *   • "offline" → signalling socket down (no cloud, no LAN)
 *   • "idle"    → mesh not initialised yet (no session)
 */
export function useMeshStatus() {
  const [snap, setSnap] = useState(() => {
    try { return getMeshStatus(); } catch (_) { return { status: "idle", peerCount: 0, peers: [] }; }
  });
  useEffect(() => {
    const unsub = subscribeMeshStatus((next) => setSnap(next));
    return unsub;
  }, []);
  return snap;
}
